import React from "react";
import "./AboutMe.css";
import img3 from "../../images/image 3 (1).svg";

const AboutMe = () => {
  return (
    <>
      <div className="AboutMeBox">
        <h3>About Me</h3>
        <div className="lower">
          <div className="left">
            <img src={img3} alt="" />
          </div>
          <div className="right">
            SDE at Ciena working on Blue Planet Inventory, with a knack for
            building things that actually ship. You'll find me on the badminton court, setting up at the volleyball
            net, or lost in music. Always learning, always building.
          </div>
        </div>
      </div>
    </>
  );
};

export default AboutMe;
